var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 12.8055L4.36112 10L7.16667 7.19446L8.13888 8.1875L6.32637 10L8.13888 11.8125L7.16667 12.8055ZM12.8333 12.8055L11.8611 11.8125L13.6736 10L11.8611 8.1875L12.8333 7.19446L15.6389 10L12.8333 12.8055ZM3.88888 17.5C3.51388 17.5 3.18865 17.3623 2.91319 17.0868C2.63773 16.8114 2.5 16.4861 2.5 16.1111V12.6111H3.88888V16.1111H7.3889V17.5H3.88888ZM12.6111 17.5V16.1111H16.1111V12.6111H17.5V16.1111C17.5 16.4861 17.3623 16.8114 17.0868 17.0868C16.8114 17.3623 16.4861 17.5 16.1111 17.5H12.6111ZM2.5 7.3889V3.88888C2.5 3.51388 2.63773 3.18865 2.91319 2.91319C3.18865 2.63773 3.51388 2.5 3.88888 2.5H7.3889V3.88888H3.88888V7.3889H2.5ZM16.1111 7.3889V3.88888H12.6111V2.5H16.1111C16.4861 2.5 16.8114 2.63773 17.0868 2.91319C17.3623 3.18865 17.5 3.51388 17.5 3.88888V7.3889H16.1111Z",
    fill: "#90A4B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlm);
export default __webpack_public_path__ + "static/media/llm.01cc36f5d0e9fcb23869e5d5643696eb.svg";
export { ForwardRef as ReactComponent };